import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "timeblock__header" }
const _hoisted_2 = { class: "timeblock__header__top" }
const _hoisted_3 = { class: "timeblock__header__content" }
const _hoisted_4 = { class: "timeblock__date-wrapper" }
const _hoisted_5 = { class: "timeblock__date" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "actions actions--mobile" }
const _hoisted_9 = { class: "timeblock__controls" }
const _hoisted_10 = { class: "timeblock__controls__time" }
const _hoisted_11 = { class: "timeblock__time-overview" }
const _hoisted_12 = {
  key: 0,
  class: "validation-error"
}
const _hoisted_13 = { class: "actions actions--desktop" }

import { computed, onMounted, onUnmounted, ref } from 'vue';
import moment from 'moment';
import ZDatepicker from '@/plugins/tm@_components/z-datepicker.vue';
import type { EmployeeFullData, TimeblockData } from './types';
import AEmployeeTimeblockHeaderActions from './a-employee-timeblock-header-actions.vue';

interface Props {
  modelValue: TimeblockData;
  minDate: Date;
  deletable: boolean;
  isEditable: boolean;
  isTimeRangeValid: boolean;
  employee: EmployeeFullData;
  index: number;
  collision: {
    hasCollision: boolean;
    startCollides: boolean;
    endCollides: boolean;
  };
  hasValidationErrors: boolean;
  hasStartTimeError: boolean;
  hasEndTimeError: boolean;
  endTimeErrorMessage?: string;
  plannedTime: string | number;
  freeTime: string | number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'a-employee-timeblock-header',
  props: {
    modelValue: {},
    minDate: {},
    deletable: { type: Boolean },
    isEditable: { type: Boolean },
    isTimeRangeValid: { type: Boolean },
    employee: {},
    index: {},
    collision: {},
    hasValidationErrors: { type: Boolean },
    hasStartTimeError: { type: Boolean },
    hasEndTimeError: { type: Boolean },
    endTimeErrorMessage: { default: '' },
    plannedTime: { default: '' },
    freeTime: { default: '' }
  },
  emits: ["previousDay", "nextDay", "updateDate", "updateStartTime", "updateEndTime", "addTimeblock", "removeTimeblock"],
  setup(__props: any) {

const props = __props;



// Check if selected date is today (disable previous day button if true)
const isCurrentDay = computed(() => {
  if (!props.modelValue.date) return false;
  return moment(props.modelValue.date).isSame(moment(), 'day');
});

const isMobile = ref(false);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => {
  handleResize();
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

const dateFormat = computed(() => {
  return isMobile.value ? 'dd.MM' : 'dd.MM.yyyy';
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, " Časový blok " + _toDisplayString(__props.index + 1) + " - " + _toDisplayString(__props.employee?._fullName), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "timeblock__date-button",
            disabled: isCurrentDay.value || !__props.isEditable,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('previousDay')))
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              _createElementVNode("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" })
            ], -1)
          ]))], 8, _hoisted_6),
          (_openBlock(), _createBlock(ZDatepicker, {
            key: dateFormat.value,
            "model-value": __props.modelValue.date,
            format: dateFormat.value,
            locale: "sk",
            "select-text": "Vybrať",
            "cancel-text": "Zrušiť",
            placeholder: "Dátum",
            "auto-apply": true,
            "enable-time-picker": false,
            "min-date": __props.minDate,
            disabled: !__props.isEditable,
            class: _normalizeClass(["timeblock__date-picker", { 'timeblock__date-picker--disabled': !__props.isEditable }]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateDate', $event)))
          }, null, 8, ["model-value", "format", "min-date", "disabled", "class"])),
          _createElementVNode("button", {
            class: "timeblock__date-button",
            disabled: !__props.isEditable,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('nextDay')))
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              _createElementVNode("path", { d: "M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" })
            ], -1)
          ]))], 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(AEmployeeTimeblockHeaderActions, {
            deletable: __props.deletable,
            onAddTimeblock: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('addTimeblock'))),
            onRemoveTimeblock: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('removeTimeblock')))
          }, null, 8, ["deletable"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_text_field, {
            value: __props.modelValue.starts_at_time,
            class: _normalizeClass({
              'error-input':
                __props.collision.startCollides ||
                !__props.isTimeRangeValid ||
                (__props.hasValidationErrors && __props.hasStartTimeError),
            }),
            disabled: !__props.isEditable,
            type: "time",
            variant: "solo",
            "bg-color": "white",
            label: "Začiatok",
            density: "compact",
            "hide-details": "",
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('updateStartTime', $event)))
          }, null, 8, ["value", "class", "disabled"]),
          _createVNode(_component_v_text_field, {
            value: __props.modelValue.ends_at_time,
            class: _normalizeClass({
              'error-input':
                __props.collision.endCollides ||
                !__props.isTimeRangeValid ||
                (__props.hasValidationErrors && __props.hasEndTimeError),
            }),
            disabled: !__props.isEditable,
            type: "time",
            variant: "solo",
            "bg-color": "white",
            label: "Koniec",
            density: "compact",
            "hide-details": "",
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('updateEndTime', $event)))
          }, null, 8, ["value", "class", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "timeblock__time-overview__label timeblock__time-overview__label--desktop" }, "Naplánovaný čas:", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "timeblock__time-overview__label timeblock__time-overview__label--mobile" }, "Nap. čas:", -1)),
            _createElementVNode("span", null, _toDisplayString(__props.plannedTime) + "h", 1)
          ]),
          _createElementVNode("p", null, [
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "timeblock__time-overview__label timeblock__time-overview__label--desktop" }, "Volný čas:", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "timeblock__time-overview__label timeblock__time-overview__label--mobile" }, "Vol. čas:", -1)),
            _createElementVNode("span", {
              style: _normalizeStyle({ color: Number(__props.freeTime) < 0 ? 'red' : undefined })
            }, _toDisplayString(__props.freeTime) + "h", 5)
          ])
        ])
      ]),
      (!__props.isTimeRangeValid || __props.endTimeErrorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(__props.endTimeErrorMessage || 'Koniec musí byť po začiatku'), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(AEmployeeTimeblockHeaderActions, {
          deletable: __props.deletable,
          onAddTimeblock: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('addTimeblock'))),
          onRemoveTimeblock: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('removeTimeblock')))
        }, null, 8, ["deletable"])
      ])
    ])
  ]))
}
}

})